const updates = [
  { date: '07-28', title: '《霸道总裁的契约恋人》最新章节第 128 话已更新', tag: '更新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-28', title: '本周人气排行榜已刷新，古风耽美作品强势登顶', tag: '排行', tagColor: 'bg-accent-100 text-accent-800' },
  { date: '07-27', title: '新作《星辰大海与你》正式上线，奇幻题材诚意之作', tag: '新作', tagColor: 'bg-secondary-100 text-secondary-800' },
  { date: '07-27', title: '韩漫腐专区新增 12 部完结全集作品，一次看个够', tag: '上新', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: '日漫腐经典系列《樱之诗》全本汉化完结上线', tag: '完结', tagColor: 'bg-accent-100 text-accent-800' },
  { date: '07-26', title: '国漫耽美原创扶持计划启动，助力本土创作者', tag: '活动', tagColor: 'bg-secondary-100 text-secondary-800' },
  { date: '07-25', title: '校园纯爱专题合集更新，精选 20 部高甜作品', tag: '合集', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-25', title: '阅读体验优化升级，下拉式加载速度提升 40%', tag: '优化', tagColor: 'bg-accent-100 text-accent-800' },
  { date: '07-24', title: 'ABO世界观专题正式上线，收录热门ABO腐漫作品', tag: '专题', tagColor: 'bg-secondary-100 text-secondary-800' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="mt-2 text-sm text-foreground-500">腐漫画网近期更新与运营快讯</p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-[19px] top-0 bottom-0 w-0.5 bg-background-200"></div>
          <div className="flex flex-col gap-0">
            {updates.map((item, idx) => (
              <a
                key={idx}
                href="#updates"
                className="relative flex items-start gap-4 pl-10 md:pl-12 py-3.5 group cursor-pointer"
              >
                <span className="absolute left-2 md:left-[11px] top-[22px] w-2.5 h-2.5 rounded-full bg-background-50 border-2 border-primary-400 group-hover:border-primary-500 group-hover:bg-primary-100 transition-colors"></span>
                <span className="flex-shrink-0 text-xs font-mono text-foreground-300 mt-1 whitespace-nowrap">{item.date}</span>
                <div className="flex-1 min-w-0">
                  <span className="text-sm text-foreground-700 group-hover:text-primary-600 transition-colors">{item.title}</span>
                </div>
                <span className={`flex-shrink-0 px-2 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${item.tagColor}`}>
                  {item.tag}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}